// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Tc1Cu","header":"styles_header__7jh3E"};